<template>
    <DBox :id="'cmp-royalty-contracts-contracts_deductions_one'" 
       :addButton="false" :addLink="true"
        :addLinkLabel="'Add Deductions'" @add_click="addDeductions">
        <NTable class="dbox1" 
        id="royalty-contracts-sidewindow-contracts_deductions_" 
        :config="tableConfig" :headers="headers"
            
        :items="deductions || []" :showNoItems="false">
            <template v-slot:item="{ item, tdcon }">
                <tr>
                    <td @click="editDeductions(item)" v-bind="tdcon('sequence')">
                        <span  class="txtov ut-link ut-text-accent5" :title="item['sequence']">
                            {{ item["sequence"] }}
                        </span>
                    </td>
                    <td  @click="editDeductions(item)" v-bind="tdcon('name')">
                        <span  class="txtov ut-link ut-text-accent5" :title="item['name']">
                            {{ item["name"] }}
                        </span>
                    </td>
                    <td v-bind="tdcon('percentage')">
                        <span class="txtov" :title="item['percentage']">
                            {{ item["percentage"] }}
                        </span>
                    </td>
                    <td v-bind="tdcon('description')">
                        <span class="txtov" :title="item['options_display']">
                            {{ item["options_display"] }}
                        </span>
                    </td>
          
                    <td v-bind="tdcon('options')">
                        <img src="static/icons/delete.svg" @click.stop="e => onDeleteDeduction(item)"
                            class="dt-icon v5 s1 ut-center" alt />
                    </td>
                </tr>
            </template>
        </NTable>
    </DBox>
</template>
  
<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
    createNTableConfig,
    createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { EventHooks } from "../../../../plugins/text-field";
import { ContractsService } from "../../services/contracts.service";
export default {
    components: {
        DBox,
        NTable
    },
    props: ['selectedContractDetails', 'deductions_target','deductions'],
    data: function () {
        return {
            textFieldConfig: {
                height: 27,
                showEditIconOnHover: false,
                box: true,
                showValidationIcons: false,

                validationEvent: EventHooks.OnBlur,
                valueChangedEvent: EventHooks.OnBlur
            },
           
        };
    },
    mounted: async function () {
      

    },
    computed: {
        tableConfig: function () {
            return createNTableConfig({
                headerStyle: 3,
                fullHeight: true,
                rowHeight: 32,
                showHeader:true,
            });
        },
        contract_id: function () {
            return this.$route.params.contract_id;
        },
        headers: function () {
            return [
                createTableHeader("sequence", { mw: 100}),
                createTableHeader("name",{ mw: 200 }),
                createTableHeader("percentage" ,{ mw: 100 }),
                createTableHeader("description"),
                createTableHeader("options", { text: false, mw: 30 })
            ];
        },
   
    },
    methods: {
        addDeductions: function () {
            this.$emit("add", this.deductions_target);
        },
        editDeductions: function (item) {
            this.$emit("edit", {deductions_target:this.deductions_target,contract_deduction_id:item.contract_deduction_id});
        },

        onEditLicencingNR: function (selectedItem) {
            this.$emit("edited", selectedItem);
        },

        onTextFieldValueChange: function ({ name, value }, item) {
            this.$emit("changed", { name, value, item });
        },
        onDeleteDeduction: function(item) {
          this.$emit("deleted", { ...item, deductions_target: this.deductions_target });
         },
   

  
    }
};
</script>
  
<style lang="scss">
.cmp-royalty-contracts-contracts_deductions_one {
    .royalty-contracts-sidewindow-contracts_deductions_ {
        // .dt-ntable {
        //     --ntable-height: none !important;
        // }
        .percent-area {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-left: 3px !important;
            margin-left: 3px !important;

            .fc2-textfield {
                flex: 1;
                width: 50%;
            }

            .percent {
                display: block;
            }
        }
    }
}
</style>
  